var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-x-transition',[(_vm.drawer.show)?_c(_vm.drawer.type,{tag:"component",staticStyle:{"z-index":"100"},attrs:{"width":_vm.drawerWidth,"permanent":"","clipped":"","app":"","mini-variant-width":"30"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }